import axios from 'axios'
import { i18n } from '../../../plugins/i18n'

export const companiesStoreMediaLibraryStore = {
  namespaced: true,
  state: {
    loading: false,
  },
  mutations: {
    prepareConnect(state) {
      state.loading = true
    },

    stopLoading(state) {
      state.loading = false
    },
  },
  actions: {
    deleteMediaLibraryStore({ commit, state, rootState }, { storeUuid, mediaLibraryId, service }) {
      if (state.loading) return

      commit('prepareConnect')
      return axios
        .delete('/api/companies/' + rootState.route.params.company_uuid + '/media/libraries/' + mediaLibraryId + '/stores/' + storeUuid + '?service=' + service)
        .then(() => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.discontinuedUse') }, { root: true })
          return true
        })
        .catch(err => {
          commit('stopLoading')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
          console.error(err)
          return false
        })
    },
  }
}
